import { combineEpics } from "redux-observable";
import { filter, map, mergeMap } from "rxjs/operators";

import { actionCreators, isOfAction } from "../actions";
import { isLoaded } from "../reducers/avatars";
import { Epic } from "../utils/types";

// helpers

const loadImage = (avatarUrl: string, ImageEl: typeof Image) =>
    new Promise<{ height: number; width: number }>((resolve, reject) => {
        const img = new ImageEl();
        img.src = avatarUrl;
        img.onload = () => {
            const { height, width } = img;
            resolve({ height, width });
        };
        img.onerror = e => {
            console.error(`Failed to load avatar ${avatarUrl}`, e);
            reject(e);
        };
    });

// epics

const onLoadAvatarRequested: Epic = (action$, state$, { Image }) =>
    action$.pipe(
        filter(isOfAction(actionCreators.loadAvatarRequested)),
        filter(({ url }) => undefined === isLoaded(state$.value, url)),
        map(({ url }) => actionCreators.loadAvatarStarted(url))
    );

const onLoadAvatarStarted: Epic = (action$, state$, { Image }) =>
    action$.pipe(
        filter(isOfAction(actionCreators.loadAvatarStarted)),
        mergeMap(({ url }) =>
            loadImage(url, Image).then(
                ({ height, width }) => actionCreators.loadAvatarSuccess(url, height, width),
                err => {
                    return actionCreators.loadAvatarFailure(url);
                }
            )
        )
    );

export const avatarEpic = combineEpics(onLoadAvatarRequested, onLoadAvatarStarted);
